import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { StatModule } from '@cargos/sprintpay-services';
import { isConfigPresent } from '@cargos/sprintpay-tools';
import { RouterValidatorDirective } from 'src/app/shared/directives/router-validator.directive';
import { ErrorHandler } from 'src/app/shared/modules/cart/lib-cart/shared/services';
import { CoreModule } from 'src/app/shared/modules/core/core.module';
import { SubscriptionAWBService } from 'src/app/shared/services';
import { AccessoriesService } from 'src/app/shared/services/accessories/accessories.service';
import { ErrorCustomHandlerService } from 'src/app/shared/services/http-error-handler.service';
import { RouteEventsService } from 'src/app/shared/services/url.service';
import { environment } from 'src/environments/environment';
import { AllianceRoutingModule } from './alliance-routing.module';
import { AllianceComponent } from './alliance.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderAllianceComponent } from './components/header/header.component';
import { FacilityInformationComponent } from './pages';
import { LoginComponent } from './pages/auth/login/login.component';
import { RecoverPasswordAllianceModule } from './pages/auth/recover-password/recover-password.module';
import { ResetPasswordAllianceModule } from './pages/auth/reset-password/reset-password.module';
import { ConfirmationAllianceModule } from './pages/cart/confirmation-alliance/confirmation.module';
import { SearchModule } from './pages/search-awb/search-awb.module';
import { AccessoriesAllianceImplementationService } from './services/accessories-alliance-implementation.service';

export function initializeServices(service: RouteEventsService): () => void {
    return () => {};
}

@NgModule({
    imports: [
        AllianceRoutingModule,
        BrowserModule,
        SearchModule,
        CoreModule.forRoot(),
        RouterValidatorDirective,
        LoginComponent,
        RecoverPasswordAllianceModule,
        ResetPasswordAllianceModule,
        ConfirmationAllianceModule,
        StatModule.forRoot({
            enableStatsig: isConfigPresent(environment.statsigSdkKey),
            sdkKey: environment.statsigSdkKey ?? '',
            user: {},
            options: {
                environment: {
                    tier: environment.environment === 'develop' ? 'development' : environment.environment,
                },
            },
        }),
    ],
    declarations: [AllianceComponent, FacilityInformationComponent, HeaderAllianceComponent, FooterComponent],
    bootstrap: [AllianceComponent],
    providers: [
        SubscriptionAWBService,
        {
            provide: AccessoriesService,
            useClass: AccessoriesAllianceImplementationService,
        },
        {
            provide: APP_INITIALIZER,
            useFactory: initializeServices,
            deps: [RouteEventsService],
            multi: true,
        },
        {
            provide: ErrorHandler,
            useClass: ErrorCustomHandlerService,
        },
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AllianceModule {}
